import i18n from "@/plugins/i18n"

const DRAFT = 'draft';
const PUBLISHED = 'published';
const REVIEW = 'review';
const SUMMING = 'summing';
const AGREEMENT = 'agreement';
const COMPLETED = 'completed';
const CANCELED = 'canceled';

const DRAFT_NAME = i18n.global.t('Черновик');
const PUBLISHED_NAME = i18n.global.t('Приём заявок');
const REVIEW_NAME = i18n.global.t('Рассмотрение заявок');
const SUMMING_NAME = i18n.global.t('Подведение итогов');
const COMPLETED_NAME = i18n.global.t('Завершена');
const CANCELED_NAME = i18n.global.t('Отменена');

function getProcedureSteps(user) {
    if (user.hasRole('ROLE_SUPPLIER')) {
        return [
            {
                name: PUBLISHED_NAME,
                code: PUBLISHED
            },
            {
                name: REVIEW_NAME,
                code: REVIEW
            },
            {
                name: SUMMING_NAME,
                code: SUMMING
            },
            {
                name: COMPLETED_NAME,
                code: COMPLETED  
            },
            {
                name: CANCELED_NAME,
                code: CANCELED
            },
        ];
    }
    return [
        {
            name: DRAFT_NAME,
            code: DRAFT
        },
        {
            name: PUBLISHED_NAME,
            code: PUBLISHED
        },
        {
            name: REVIEW_NAME,
            code: REVIEW
        },
        {
            name: SUMMING_NAME,
            code: SUMMING
        },
        {
            name: COMPLETED_NAME,
            code: COMPLETED  
        },
        {
            name: CANCELED_NAME,
            code: CANCELED
        },
    ];
}

const COLORS = {
    draft: 'var(--step-draft-color)',
    published: 'var(--step-published-color)',
    review: 'var(--step-review-color)',
    summing: 'var(--step-summing-color)',
    agreement: 'var(--step-agreement-color)',
    canceled: 'var(--step-canceled-color)',
};

const DEADLINES = {
    published: 'applicationDeadline',
    review: 'reviewDeadline',
    summing: 'summingStart',
};

function getStatusColor(stepCode)
{
    return COLORS[stepCode] ?? COLORS[DRAFT];
}

function getStatusStyle(stepCode)
{
    return `background-color: ${getStatusColor(stepCode)} !important;`;
}

function getDeadlineField(stepCode)
{
    return DEADLINES[stepCode];
}

export default {
    DRAFT,
    PUBLISHED,
    REVIEW,
    SUMMING,
    AGREEMENT,
    COMPLETED,
    COMPLETED_NAME,
    CANCELED,
    COLORS,
    getStatusColor,
    getStatusStyle,
    getProcedureSteps,
    getDeadlineField
}
